<template>
  <div id="item-table">
    <b-container fluid>
      <b-row>
        <b-col class="pl-0">
          <add-item-other-platform-component
            :add-item-input.sync="addItemInput"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col class="pl-0">
          <item-table-other-platform-component
            :item-table="orderSelectItems"
            :delete-item-handler="deleteItemHandler"
          />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import AddItemOtherPlatformComponent from "./AddItemOtherPlatformComponent";
import ItemTableOtherPlatformComponent from "./ItemTableOtherPlatformComponent";
export default {
    name: "AddItemTableCashAddDocumentComponent",
    components: {
        AddItemOtherPlatformComponent,
        ItemTableOtherPlatformComponent
    },
    props: {
        orderSelectItems: {
            type: Array
        },

    },
    data() {
        return {
            addItemInput: {
                item_quantity: "",
                item_price: "",
                item_name: "",
                item_code: ""
            },

        };
    },
    watch: {
        addItemInput(newVal, oldVal) {
            let oldOrderSelectItems = this.orderSelectItems;
            oldOrderSelectItems.push(newVal);
            this.$emit("update:orderSelectItems", oldOrderSelectItems);
        }
    },
    methods: {
      deleteItemHandler(index) {
        this.$bvModal.msgBoxConfirm('โปรดยืนยันในการลบข้อมูล.', {
          title: 'ยืนยันการลบ',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'ลบ',
          cancelTitle: 'ยกเลิก',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        })
          .then(value => {
            if (value) {
              let oldOrderSelectItems = this.orderSelectItems;
              oldOrderSelectItems.splice(index , 1);
              this.$emit("update:orderSelectItems", oldOrderSelectItems);
            }
          })
          .catch(err => {
            // An error occurred
          })
      }
    }
};
</script>

<style scoped></style>
